import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DinaUppgifterService } from '../../services/dina-uppgifter.service';
import { MobileStateService } from '../../services/mobile/mobile-state.service';
import { Subscription } from 'rxjs';
import { SammanstallningStoreService } from '../../stores/sammanstallning.store';
import { ModalService } from '../../services/modal/modal.service';
import { ErrorService } from '../../services/error/error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorType } from '../../services/error/errorType';

@Component({
  selector: 'app-ditt-underlag',
  templateUrl: './dina-uppgifter.page.html',
  styleUrls: []
})
export class DinaUppgifterPageComponent implements OnInit, OnDestroy {
  isMobileResolution = false;

  private subscriptions: Subscription[] = [];

  serverError: HttpErrorResponse = null;

  constructor(
    public sammanstallningStoreService: SammanstallningStoreService,
    public dinaUppgifterService: DinaUppgifterService,
    private readonly mobileStateService: MobileStateService,
    private readonly modalService: ModalService,
    private readonly errorService: ErrorService,
    private readonly router: Router) {
  }

  ngOnInit() {
    this.isMobileResolution = this.mobileStateService.isMobile();

    this.subscriptions.push(
      this.mobileStateService.isMobile$.subscribe((result: boolean) => {
        this.isMobileResolution = result;
      })
    );

    this.errorService.errorSubject.subscribe((res) => {
      this.serverError = res;
    });
  }

  onCalculate(): void {
    this.errorService.notify(null);

    if (this.dinaUppgifterService.isFormDirty()) {
      this.modalService.openPapaendeInmatning(() => {
      });
    } else {
      this.dinaUppgifterService.calculate().then(
        response => {
          console.log('HTTP response', response);
          this.router.navigate(['ditt-underlag/resultat']);
          this.dinaUppgifterService.deselectCurrentItem();
        },
        (err: HttpErrorResponse) => {
          console.log('HTTP Error', err);
        });
    }
  }

  onCancel(): void {
    this.modalService.openClearAll(() => {
      this.dinaUppgifterService.clearAll();
    });
  }

  unsubscribeSubscriptions(): void {
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  isRegelmotorInternalError() {
    return this.serverError?.error.error === ErrorType.INTERNAL_SERVER_ERROR;
  }

}
